"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedVersions = void 0;
exports.supportedVersions = ['1.8.8', '1.9.4', '1.10.2', '1.11.2', '1.12.2', '1.13.2', '1.14.4', '1.15.2', '1.16.1'];
